module.exports = __webpack_public_path__ + "img/icons_UI_chevron_right_black.52cb41a0.svg";